import { AsyncPipe, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { FreshMainPageComponent } from '../../layout/fresh/fresh-main-page/fresh-main-page.component';
import { ConfigRepository } from '../../shared/repositories/config.repository';
import { Layout } from '../../api/v1/models/layout';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  standalone: true,
  imports: [
    NgSwitch,
    NgSwitchCase,
    AsyncPipe,
    FreshMainPageComponent,
  ]
})
export class MainComponent {
  constructor(
    private config: ConfigRepository,
  ) {}
  layout$: Observable<Layout> = this.config.layout$;
  layouts = Layout;
}
